import type { ReactNode } from "react"
import { Box, Stack, Typography } from "@mui/material"

interface RowProps {
  label: string
  alignTop?: boolean
  children: ReactNode
}

const Row = ({ label, alignTop, children }: RowProps) => (
  <Stack
    direction="row"
    justifyContent="space-between"
    alignItems={alignTop ? "flex-start" : "center"}
    gap={2}
    paddingY={1.25}
  >
    <Typography color="text.secondary" flexShrink={0}>
      {label}
    </Typography>
    <Box minWidth={0} textAlign="right">
      {children}
    </Box>
  </Stack>
)

export default Row
